import { DefaultButton } from "@fluentui/react/lib/Button";
import { TextField } from "@fluentui/react/lib/TextField";
import _debounce from "lodash.debounce";
import React, { Component } from "react";
import ResponsivePagination from "react-responsive-pagination";
import { Link } from "react-router-dom";
import {
  CircularByCorporate,
  CircularFileByAdmin,
  CircularFileForAll,
  getAccessList,
  getFileStatus,
  getSearchResult,
  getSearchResultForCorporate,
  searchWithKeywords,
} from "../../actions/Circular";
import { getDepartmentList } from "../../actions/MasterAction";
import Header from "../../component/common/Header";
import { default as CONSTANT, default as constant } from "../../constant";
import { getCookie, getDateParts, onChange, setOptions } from "../../utils";
import TableShimmer from "../common/Shimmer";
export default class CircularList extends Component {
  constructor(props) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      accessList: [],

      //for me
      admin_list: undefined, // admin circular list
      admin_total: 0, // admin total
      a_pn: 1, // admin page number

      // for corporate
      corporate_department: {
        name: "corporate_department",
        value: [],
        options: [],
        error: "",
        required: true,
      },
      corporate_list: undefined, // admin circular list
      corporate_total: 0, // admin total
      c_pn: 1, // admin page number

      // for reginal
      all_users_list: undefined, // for all users
      au_total: 0, // all users total
      au_pn: 1, // all users page number

      page: 1,
      limit: 20,
      pending: undefined,
      list: undefined,
      userDetail,
      departmentOptions: [],
      activeFilter: constant.filterType.default,

      // form data for corporate
      c_fromDate: { name: "c_fromDate", value: "", error: "", required: true },
      c_toDate: { name: "c_toDate", value: "", error: "", required: true },
      c_department: {
        name: "c_department",
        value: [],
        options: [],
        error: "",
        required: true,
      },
      c_keyword: {
        name: "c_keyword",
        value: "",
        options: [],
        error: "",
        required: true,
      },

      // form data for regional
      fromDate: { name: "fromDate", value: "", error: "", required: true },
      toDate: { name: "toDate", value: "", error: "", required: true },
      department: {
        name: "department",
        value: [],
        options: [],
        error: "",
        required: true,
      },
      keyword: {
        name: "keyword",
        value: "",
        options: [],
        error: "",
        required: true,
      },

      // table properties
      table_classes: [
        "cirLcolor",
        "cirLcolorOne",
        "cirLcolorTwo",
        "cirLcolorThree",
        "cirLcolorFour",
      ],

      table_w: { width: "6rem" },
      table_sn: { width: "0rem" },
    };

    this.onChange = this.onChange.bind(this);

    this.debouncedSearch = _debounce(this.handleSearch, 500);
  }

  getCircularFileByAdmin() {
    CircularFileByAdmin()
      .then((c_data_by_admin) => {
        if (c_data_by_admin.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            admin_list: c_data_by_admin.result.list,
            admin_total: c_data_by_admin.result.total,
          });
        }
      })
      .catch((err) => {
        console.log("some error occured ");
        // alert("some error occured ")
      });
  }

  getCircularForCorporate() {
    CircularByCorporate(1, '', '', '', '')
      .then((c_data_by_cp) => {
        if (c_data_by_cp.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            corporate_list: c_data_by_cp.result.list,
            corporate_total: c_data_by_cp.result.total,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ");
      });
  }

  getCircularFileForAll() {
    CircularFileForAll(1, '', '', '', '') // Pass all parameters with empty values
      .then((all_users_list) => {
        if (all_users_list.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            all_users_list: all_users_list.result.list,
            au_total: all_users_list.result.total,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ", err);
      });
  }

  openDetailPage = (url, fileCode) => {
    //  window.open(url ,  'Child Window', 'popup' );
    let q;
    let file_url = ` ${process.env.REACT_APP_BASE_URL}get-circular-file/?q=${q} `;
    getFileStatus(fileCode)
      .then((res) => {
        if (res.status == "success") {
          if (res.result.count == 1) {
            // one attachment
            window.open(
              `${process.env.REACT_APP_BASE_URL}get-circular-file/?q=${fileCode}/${res.result.fileName}`,
              "_blank"
            );
          } else if (res.result.count == 0) {
            // zero attachment
            this.props.history.push(url);
          } else {
            // more than one attachment
            this.props.history.push(url);
          }
        }
      })
      .catch((err) => { });
  };

  getAccesList() {
    getAccessList()
      .then((res) => {
        if (res.status == constant.static.apiStatus.success) {
          this.setState({ ...this.state, accessList: res.result });
        }
      })
      .catch((err) => {
        console.log("some error occured  while fetching acccess list ", err);
      });
  }

  componentDidMount() {
    this.getCircularFileByAdmin(); // circualr created By Me

    this.getAccesList(); // access list
    this.getCircularForCorporate(); // for corporate

    this.getCircularFileForAll(); // regional circular data

    this.getDepartment(); //      getting department
  }

  getSearchResult(pn = 1) {
    const { fromDate, toDate, department, keyword } = this.state;

    // Use the same API with all filter parameters
    CircularFileForAll(
      pn,
      keyword.value,
      department.value,
      fromDate.value,
      toDate.value
    )
      .then((all_users_list) => {
        if (all_users_list.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            all_users_list: all_users_list.result.list,
            au_total: all_users_list.result.total,
            activeFilter: constant.filterType.regional.f2,
            au_pn: pn,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ", err);
      });
  }

  getSearchResultForCorporate(active_filter, pn = 1) {
    const { c_fromDate, c_toDate, corporate_department, c_keyword } = this.state;

    // Use the same API with all filter parameters
    CircularByCorporate(
      pn,
      c_keyword.value,
      corporate_department.value,
      c_fromDate.value,
      c_toDate.value
    )
      .then((all_users_list) => {
        if (all_users_list.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            corporate_list: all_users_list.result.list,
            corporate_total: all_users_list.result.total,
            activeFilter: active_filter,
            c_pn: pn,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ", err);
      });
  }

  getDepartment() {
    getDepartmentList().then((res) => {
      setOptions(
        this,
        this.state.corporate_department.name,
        res.result.filter((ele) => {
          if (CONSTANT.corporate_dpt_id.some((item) => item == ele.code)) {
            return ele;
          }
        })
      ); // corporate regional

      setOptions(
        this,
        this.state.department.name,
        res.result.filter((ele) => {
          if (CONSTANT.regional_dpt_id.some((item) => item == ele.code)) {
            return ele;
          }
        })
      ); // for regional
    });
  }

  adminPaginate(pn) {
    CircularFileByAdmin(pn)
      .then((c_data_by_admin) => {
        if (c_data_by_admin.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            admin_list: c_data_by_admin.result.list,
            admin_total: c_data_by_admin.result.total,
            a_pn: pn,
          });
        }
      })
      .catch((err) => {
        console.log("some error occured ");
        // alert("some error occured ");
      });
  }

  allUsersPaginate(pn, type) {
    const { keyword, fromDate, toDate, department } = this.state;

    CircularFileForAll(
      pn,
      keyword.value,
      department.value,
      fromDate.value,
      toDate.value
    )
      .then((all_users_list) => {
        if (all_users_list.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            all_users_list: all_users_list.result.list,
            au_total: all_users_list.result.total,
            au_pn: pn,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ", err);
      });
  }

  handlePageChange = (newPage) => {
    this.corporateUsersPaginate(newPage, "");
  };

  // corporateUsersPaginate(pn, type) {
  //   if (type == constant.filterType.corporate.default || type == "") {
  //     CircularByCorporate(pn)
  //       .then((crpt_users_list) => {
  //         if (crpt_users_list.status == constant.static.apiStatus.success) {
  //           this.setState({
  //             ...this.state,
  //             corporate_list: crpt_users_list.result.list,
  //             corporate_total: crpt_users_list.result.total,
  //             c_pn: pn,
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("some error occured ", err);
  //         //   alert("some error occured ");
  //       });
  //   } else if (type == constant.filterType.corporate.f2) {
  //     const { c_fromDate, c_toDate, c_department, corporate_department } =
  //       this.state;

  //     let model = {
  //       fromDate: c_fromDate.value,
  //       toDate: c_toDate.value,
  //       dept: Number(corporate_department.value),
  //       pageNo: pn,
  //     };

  //     getSearchResultForCorporate(model)
  //       .then((all_users_list) => {
  //         if (all_users_list.status == constant.static.apiStatus.success) {
  //           this.setState({
  //             ...this.state,
  //             corporate_list: all_users_list.result.list,
  //             corporate_total: all_users_list.result.total,
  //             activeFilter: type,
  //             c_pn: pn,
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("some error occured ", err);
  //         //   alert("some error occured ");
  //       });
  //   }

  //   //   if(type==constant.filterType.f2) {
  //   //    this.getSearchResult(pn)
  //   //   }
  // }
  corporateUsersPaginate(pn, type) {
    const { c_keyword, c_fromDate, c_toDate, corporate_department } = this.state;

    CircularByCorporate(
      pn,
      c_keyword.value,
      corporate_department.value,
      c_fromDate.value,
      c_toDate.value
    )
      .then((crpt_users_list) => {
        if (crpt_users_list.status == constant.static.apiStatus.success) {
          this.setState({
            ...this.state,
            corporate_list: crpt_users_list.result.list,
            corporate_total: crpt_users_list.result.total,
            c_pn: pn,
          });
        }
      })
      .catch((err) => {
        console.log("some error occurred ", err);
      });
  }
  onChange(e) {
    const { name, value } = e.target;
    this.setState({
      ...this.state,
      [name]: { ...this.state[name], value: value },
    });
  }

  handleSearch = (searchValue, searchType) => {
    if (searchType == constant.filterType.corporate.f1) {
      const { c_fromDate, c_toDate, corporate_department } = this.state;

      // Use the same API with all current filters
      CircularByCorporate(
        1,
        searchValue,
        corporate_department.value,
        c_fromDate.value,
        c_toDate.value
      )
        .then((c_data_by_cp) => {
          if (c_data_by_cp.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              corporate_list: c_data_by_cp.result.list,
              corporate_total: c_data_by_cp.result.total,
              c_pn: 1,
              activeFilter: searchValue ? constant.filterType.corporate.f1 : constant.filterType.corporate.default,
            });
          }
        })
        .catch((err) => {
          console.log("some error occurred ", err);
        });
    }

    // For when search is cleared
    else if (searchValue == "" && searchType == constant.filterType.corporate.f1) {
      const { c_fromDate, c_toDate, corporate_department } = this.state;

      CircularByCorporate(
        1,
        '',
        corporate_department.value,
        c_fromDate.value,
        c_toDate.value
      )
        .then((c_data_by_cp) => {
          if (c_data_by_cp.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              corporate_list: c_data_by_cp.result.list,
              corporate_total: c_data_by_cp.result.total,
              c_pn: 1,
              activeFilter: "",
            });
          }
        })
        .catch((err) => {
          console.log("some error occurred ");
        });
    } else if (
      searchValue == "" &&
      searchType == constant.filterType.corporate.f1
    ) {
      // for default  corporate
      CircularByCorporate()
        .then((c_data_by_cp) => {
          if (c_data_by_cp.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              corporate_list: c_data_by_cp.result.list,
              corporate_total: c_data_by_cp.result.total,
              activeFilter: "",
            });
          }
        })
        .catch((err) => {
          console.log("some error occured ");
          //   alert("some error occured ");
        });
    } // Regional search with keyword
    if (searchValue != "" && searchType == constant.filterType.regional.f1) {
      const { fromDate, toDate, department } = this.state;

      CircularFileForAll(
        1,
        searchValue,
        department.value,
        fromDate.value,
        toDate.value
      )
        .then((all_users_list) => {
          if (all_users_list.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              all_users_list: all_users_list.result.list,
              au_total: all_users_list.result.total,
              au_pn: 1,
              activeFilter: constant.filterType.regional.f1,
            });
          }
        })
        .catch((err) => {
          console.log("some error occurred ", err);
        });
    }
    // When regional search is cleared
    else if (searchValue == "" && searchType == constant.filterType.regional.f1) {
      const { fromDate, toDate, department } = this.state;

      CircularFileForAll(
        1,
        '',
        department.value,
        fromDate.value,
        toDate.value
      )
        .then((all_users_list) => {
          if (all_users_list.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              all_users_list: all_users_list.result.list,
              au_total: all_users_list.result.total,
              au_pn: 1,
              activeFilter: constant.filterType.regional.default,
            });
          }
        })
        .catch((err) => {
          console.log("some error occurred ", err);
        });
    }
    else if (searchValue == "" && searchType == constant.filterType.regional.default) {
      // default regional circular
      CircularFileForAll(1, '', '', '', '')
        .then((all_users_list) => {
          if (all_users_list.status == constant.static.apiStatus.success) {
            this.setState({
              ...this.state,
              all_users_list: all_users_list.result.list,
              au_total: all_users_list.result.total,
              au_pn: 1,
              activeFilter: "",
            });
          }
        })
        .catch((err) => {
          console.log("some error occurred ", err);
        });
    }
  };

  randomIntFromInterval(min, max) {
    // min and max included
    let i = 0;
    return () => {
      if (i > 6) {
        i = 0;
        return i;
      } else {
        i++;
        return i;
      }
    };
  }

  render() {
    const {
      page,
      limit,
      list,
      userDetail,
      admin_list,
      admin_total,
      a_pn,

      au_total,
      au_pn,
      all_users_list,
      accessList,
    } = this.state;

    const {
      fromDate,
      toDate,
      department,
      keyword,
      table_classes,
      activeFilter,
      table_w,
      table_sn,
    } = this.state;

    const { corporate_list, corporate_department, corporate_total, c_pn } =
      this.state;

    const tbleClasses = this.randomIntFromInterval();

    const { c_fromDate, c_toDate, c_department, c_keyword } = this.state;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card homedob p-4 mb-4">
                <div className="row mb-3">
                  <div className="col-md-10">
                    <h3 className="page-title">
                      {" "}
                      EPIL CORPORATE OFFICE CIRCULAR / INFORMATION{" "}
                    </h3>
                  </div>
                  <div className="col-md-2 text-end">
                    <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn-back-home"
                    >
                      Go Back
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="bg">
                    <div className="row circlar-search-bg">
                      <div className="col-md-9 p-2">
                        <span> {corporate_total} - search results </span>

                        <TextField
                          name={c_keyword.name}
                          value={c_keyword.value}
                          onChange={(e) => {
                            onChange(
                              this,
                              this.state.c_keyword.name,
                              e.target.value
                            );
                            this.debouncedSearch(
                              e.target.value,
                              CONSTANT.filterType.corporate.f1
                            );
                          }}
                          placeholder=" Search By Keyword"
                        />
                      </div>
                      <div className="col-md-3 text-end">
                        <div class="d-flex justify-content-end mt-3">
                          {accessList &&
                            accessList.some(
                              (ele) => ele.code == userDetail.code
                            ) && (
                              <Link
                                to={CONSTANT.component.circularListAdd.url}
                                className="btn btn-sm submit-button mt-2"
                              >
                                <i className="fa fa-plus-circle mt-2" />
                                Add File
                              </Link>
                            )}

                          <button
                            className="btn btn-sm submit-button mt-2 ml-2"
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                activeFilter: constant.filterType.default,
                              });
                            }}
                          >
                            Reset to default
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <div className="row align-items-center m-0 search-tab-data-bg py-2">
                      <div className="col-lg-3 col-md-6 col-12 d-flex align-items-center">
                        {" "}
                        FROM:
                        <input
                          type="date"
                          className="form-control mb-1"
                          name={c_fromDate.name}
                          value={c_fromDate.value}
                          onChange={this.onChange}
                        />
                      </div>

                      <div className="col-lg-3 col-md-6 col-12 d-flex align-items-center">
                        {" "}
                        TO:
                        <input
                          type="date"
                          className="form-control mb-1"
                          name={c_toDate.name}
                          value={c_toDate.value}
                          onChange={this.onChange}
                        />
                      </div>

                      <div className="col-lg-4 col-md-6 col-12">
                        <select
                          className="form-control mb-1"
                          name={corporate_department.name}
                          value={corporate_department.value}
                          onChange={this.onChange}
                        >
                          <option value=""> select Corporate </option>

                          {corporate_department.options.length > 0 &&
                            corporate_department.options.map((ele) => {
                              return (
                                <option value={ele.code}> {ele.name} </option>
                              );
                            })}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-6 col-12 text-nowrap">
                        <DefaultButton
                          text="Search"
                          onClick={() =>
                            this.getSearchResultForCorporate(
                              constant.filterType.corporate.f2
                            )
                          }
                          allowDisabledFocus
                        />
                        <DefaultButton
                          text="Reset"
                          className="ml-1"
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              c_fromDate: {
                                name: "c_fromDate",
                                value: "",
                                error: "",
                                required: true,
                              },
                              c_toDate: {
                                name: "c_toDate",
                                value: "",
                                error: "",
                                required: true,
                              },
                              c_keyword: {
                                name: "c_keyword",
                                value: "",
                                error: "",
                                required: true,
                              },
                              corporate_department: {
                                ...this.state.corporate_department,
                                name: "corporate_department",
                                value: "",
                                error: "",
                                required: true,
                              },
                              activeFilter: constant.filterType.default,
                            }, () => {
                              // After state is reset, fetch default data
                              this.getCircularForCorporate();
                            });
                          }}
                          allowDisabledFocus
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="list-container">
                      <div className="table-container">
                        <div className="table-wrapper radius-4">
                          <table className="tablen">
                            <thead>
                              <tr className="text-center">
                                <th
                                  scope="col"
                                  className="table-dark"
                                  style={{ width: "2%" }}
                                >
                                  {" "}
                                  S.No.
                                </th>
                                <th
                                  scope="col"
                                  className="table-dark"
                                  style={{ width: "10%" }}
                                >
                                  {" "}
                                  Circular Number{" "}
                                </th>
                                <th
                                  scope="col"
                                  className="table-dark"
                                  style={{ width: "10%" }}
                                >
                                  {" "}
                                  Issued On{" "}
                                </th>
                                <th
                                  scope="col"
                                  className="table-dark"
                                  style={{ width: "8%" }}
                                >
                                  {" "}
                                  Issued By{" "}
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Title{" "}
                                </th>
                                <th
                                  scope="col"
                                  className="table-dark"
                                  style={{ width: "15%" }}
                                >
                                  {" "}
                                  Keywords{" "}
                                </th>
                                {/* <th scope="col" className='table-dark' > Action  </th> */}
                                {/* <th scope="col">Closed in (Days)</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {corporate_list === undefined && (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    {" "}
                                    <TableShimmer />{" "}
                                  </td>
                                </tr>
                              )}

                              {corporate_list &&
                                corporate_list.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      {" "}
                                      No records found{" "}
                                    </td>
                                  </tr>
                                )}

                              {corporate_list &&
                                corporate_list.length > 0 &&
                                corporate_list.map((item, index) => {
                                  const detailPageURL =
                                    CONSTANT.component.circularFileDetail.url.replace(
                                      ":fileCode",
                                      item.id
                                    );
                                  const dated = getDateParts(item.CreatedOn);
                                  const mo = getDateParts(item.UpdatedOn);
                                  const co = getDateParts(item.closedOn);

                                  return (
                                    <tr
                                      key={index}
                                      className={`c-pointer text-center ${table_classes[tbleClasses()]
                                        } `}
                                      onClick={() => {
                                        this.openDetailPage(
                                          detailPageURL,
                                          item.id
                                        );
                                      }}
                                    >
                                      <td
                                        className="sno text-wrap"
                                        style={table_sn}
                                      >
                                        {(c_pn - 1) * limit + index + 1}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.CircularNumber}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        <span className="status-badge created text-nowrap">{`${dated.date} ${dated.monthName} ${dated.year}`}</span>{" "}
                                      </td>
                                      <td
                                        className="subject text-wrap"
                                        style={table_w}
                                      >
                                        {" "}
                                        {item.issuedBy}{" "}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.title}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.Keyword.length > 20
                                          ? item.Keyword.slice(0, 50) + "..."
                                          : item.Keyword}
                                      </td>
                                      {/* <td   > <Link to={detailPageURL} target="_blank"> Open   </Link>  </td> */}
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {activeFilter != constant.filterType.corporate.f1 && (
                  <nav
                    aria-label="Page navigation example "
                    className="d-flex justify-center"
                  >
                    <ul class="pagination mt-4">
                      {new Array(Math.ceil(corporate_total / limit))
                        .fill(undefined)
                        .map((ele, i) => {
                          return (
                            <li
                              className={`page-item cursor-pointer ${c_pn == i + 1 ? "active" : ""
                                } `}
                              onClick={() =>
                                this.corporateUsersPaginate(i + 1, activeFilter)
                              }
                            >
                              {" "}
                              <span className="page-link">{i + 1} </span>{" "}
                            </li>
                          );
                        })}
                    </ul>
                  </nav>
                )} */}

                {activeFilter != constant.filterType.corporate.f1 && (
                  <>
                    <ResponsivePagination
                      activeItemClassName="Pagi-number-ac"
                      current={c_pn}
                      maxWidth={1}
                      total={Math.ceil(corporate_total / limit)}
                      onPageChange={(page) => {
                        this.corporateUsersPaginate(page, activeFilter);
                      }}
                    />
                  </>
                )}
              </div>

              {/*  epil corporate  */}

              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="list-container">
                      <h3 className="page-title">
                        {" "}
                        EPIL REGIONAL OFFICE CIRCULAR / INFORMATION{" "}
                      </h3>
                      <span> {au_total} - search results </span>

                      <TextField
                        name={keyword.name}
                        value={keyword.value}
                        onChange={(e) => {
                          onChange(
                            this,
                            this.state.keyword.name,
                            e.target.value
                          );
                          this.debouncedSearch(
                            e.target.value,
                            e.target.value == ""
                              ? constant.filterType.regional.default
                              : constant.filterType.regional.f1
                          );
                        }}
                        placeholder=" Search By Keyword"
                      />

                      {/*  <div className='col-2'>
                                  <DefaultButton text="Search"   onClick={()=> this.getSearchResult()} allowDisabledFocus   />
                           </div>  */}

                      <div className="col-md-12 p-0 mt-3">
                        <div className="row align-items-center m-0 search-tab-data-bg py-2">
                          <div className="col-lg-3 col-md-6 col-12 d-flex align-items-center">
                            {" "}
                            FROM:
                            <input
                              type="date"
                              className="form-control mb-1"
                              name={fromDate.name}
                              value={fromDate.value}
                              onChange={this.onChange}
                            />
                          </div>

                          <div className="col-lg-3 col-md-6 col-12 d-flex align-items-center">
                            {" "}
                            TO:
                            <input
                              type="date"
                              className="form-control mb-1"
                              name={toDate.name}
                              value={toDate.value}
                              onChange={this.onChange}
                            />
                          </div>

                          <div className="col-lg-4 col-md-6 col-12">
                            <select
                              className="form-control mb-1"
                              name={department.name}
                              value={department.value}
                              onChange={this.onChange}
                            >
                              <option value=""> select Region </option>
                              {department.options.length > 0 &&
                                department.options.map((ele) => {
                                  return (
                                    <option value={ele.code}>
                                      {" "}
                                      {ele.name}{" "}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="col-lg-2 col-md-6 col-12 flex">
                            <DefaultButton
                              text="Search"
                              className="ml-1"
                              onClick={() => this.getSearchResult()}
                              allowDisabledFocus
                            />
                            <DefaultButton
                              text="Reset"
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  fromDate: {
                                    name: "fromDate",
                                    value: "",
                                    error: "",
                                    required: true,
                                  },
                                  toDate: {
                                    name: "toDate",
                                    value: "",
                                    error: "",
                                    required: true,
                                  },
                                  keyword: {
                                    name: "keyword",
                                    value: "",
                                    error: "",
                                    required: true,
                                  },
                                  department: {
                                    ...this.state.department,
                                    name: "department",
                                    value: "",
                                    error: "",
                                    required: true,
                                  },
                                  activeFilter: constant.filterType.default,
                                }, () => {
                                  // After state is reset, fetch default data
                                  this.getCircularFileForAll();
                                });
                              }}
                              allowDisabledFocus
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="list-container">
                      <div className="table-container">
                        <div className="table-wrapper radius-4">
                          <table className="tablen">
                            <thead>
                              <tr className="text-center">
                                <th scope="col" className="table-dark">
                                  {" "}
                                  S.No.
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Circular Number{" "}
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Issued On{" "}
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Issued By{" "}
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Title{" "}
                                </th>
                                <th scope="col" className="table-dark">
                                  {" "}
                                  Keywords{" "}
                                </th>
                                {/* <th scope="col" className='table-dark' > Action  </th> */}
                                {/* <th scope="col">Closed in (Days)</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {all_users_list === undefined && (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    {" "}
                                    <TableShimmer />{" "}
                                  </td>
                                </tr>
                              )}

                              {all_users_list &&
                                all_users_list.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      {" "}
                                      No records found{" "}
                                    </td>
                                  </tr>
                                )}

                              {all_users_list &&
                                all_users_list.length > 0 &&
                                all_users_list.map((item, index) => {
                                  const detailPageURL =
                                    CONSTANT.component.circularFileDetail.url.replace(
                                      ":fileCode",
                                      item.id
                                    );
                                  const dated = getDateParts(item.CreatedOn);
                                  const mo = getDateParts(item.UpdatedOn);
                                  const co = getDateParts(item.closedOn);

                                  return (
                                    <tr
                                      key={index}
                                      className={`c-pointer text-center ${table_classes[tbleClasses()]
                                        } `}
                                      onClick={() => {
                                        this.openDetailPage(
                                          detailPageURL,
                                          item.id
                                        );
                                      }}
                                    >
                                      <td
                                        className="text-wrap"
                                        style={table_sn}
                                      >
                                        {(au_pn - 1) * limit + index + 1}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.CircularNumber}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {`${dated.date} ${dated.monthName} ${dated.year}`}{" "}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {" "}
                                        {item.issuedBy}{" "}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.title}
                                      </td>
                                      <td className="text-wrap" style={table_w}>
                                        {item.Keyword.length > 20
                                          ? item.Keyword.slice(0, 50) + "..."
                                          : item.Keyword}
                                      </td>
                                      {/* <td   > <Link to={detailPageURL} target="_blank"> Open   </Link>  </td> */}
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* {activeFilter != constant.filterType.regional.f1 && (
                  <nav
                    aria-label="Page navigation example "
                    className="d-flex justify-center"
                  >
                    <ul class="pagination mt-4">
                      {new Array(Math.ceil(au_total / limit))
                        .fill(undefined)
                        .map((ele, i) => {
                          return (
                            <li
                              className={`page-item cursor-pointer ${au_pn == i + 1 ? "active" : ""
                                } `}
                              onClick={() =>
                                this.allUsersPaginate(i + 1, activeFilter)
                              }
                            >
                              {" "}
                              <span className="page-link">{i + 1} </span>{" "}
                            </li>
                          );
                        })}
                    </ul>
                  </nav>
                )} */}

                <div className="mt-4">
                  {activeFilter != constant.filterType.regional.f1 && (
                    <>
                      <ResponsivePagination
                        current={au_pn}
                        activeItemClassName="Pagi-number-ac"
                        maxWidth={1}
                        total={Math.ceil(au_total / limit)}
                        onPageChange={(page) => {
                          this.allUsersPaginate(page, activeFilter);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
